import * as request from '../../request'
import * as serializers from './serializers'

// eslint-disable-next-line import/prefer-default-export
export const getMenuResource = async () => {
  try {
    const res = await request.get(
      `v1/menu/platform/${process.env.PLATFORM_WEB}`
    )

    return serializers.menuList(res.data)
  } catch (err) {
    return Promise.reject(err)
  }
}
